module.exports = __webpack_public_path__ + "static/media/img11.f1692d9f.jpg";